// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"10":"ad78452c41cd2253","83":"3a2e0293b406d846","464":"e78ca4f86fd9b5ca","554":"a79ec670427750e1","570":"9c4c7e33c54d1a64","704":"31f9b25b8efc8c5b","864":"8cf00bd4a0bb6c78","878":"2d2e3f5127b7ff08"}[chunkId] + ".js";
};